import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { cn } from 'lib/utils';
import { UpdatePassword } from 'features/profile/component/modals/update-password/update-password';
import googleIcon from 'assets/images/social_media_google.svg';
import { AccountRow } from './account-row';
import {
  accountOutlineButtonClassName,
  accountSectionClassName,
  accountSectionTitleClassName,
} from './account-styles';

interface SigningInCardProps {
  isGoogleLinked: boolean;
}

/** Password uses the same change-password dialog as the Settings dialog. */
export function SigningInCard({ isGoogleLinked }: SigningInCardProps) {
  const { t } = useTranslation();
  const [isPasswordDialogOpen, setIsPasswordDialogOpen] = useState(false);

  return (
    <section className={cn(accountSectionClassName, 'px-6 pb-2 pt-5')}>
      <h2 className={accountSectionTitleClassName}>
        {t('ACCOUNT_SIGNING_IN', { defaultValue: 'Signing in' })}
      </h2>

      <AccountRow
        title={t('ACCOUNT_PASSWORD', { defaultValue: 'Password' })}
        hint={t('UPDATE_PASSWORD_KEEP_ACCOUNT_SAFE')}
        isLast={!isGoogleLinked}
      >
        <div className="flex w-full sm:justify-end">
          <button
            type="button"
            onClick={() => setIsPasswordDialogOpen(true)}
            className={accountOutlineButtonClassName}
          >
            {t('ACCOUNT_CHANGE_PASSWORD', { defaultValue: 'Change password' })}
          </button>
        </div>
      </AccountRow>

      {isGoogleLinked ? (
        <AccountRow
          title={t('ACCOUNT_SIGN_IN_WITH_GOOGLE', { defaultValue: 'Sign in with Google' })}
          hint={t('ACCOUNT_LINKED_TO_YOUR_ACCOUNT', { defaultValue: 'Linked to your account' })}
          isLast
        >
          <div className="flex min-h-10 w-full items-center sm:justify-end">
            <img src={googleIcon} alt="Google" width={18} height={18} className="shrink-0" />
          </div>
        </AccountRow>
      ) : null}

      <UpdatePassword
        open={isPasswordDialogOpen}
        onOpenChange={setIsPasswordDialogOpen}
        onClose={() => setIsPasswordDialogOpen(false)}
      />
    </section>
  );
}
